
import { Layout } from 'antd';
import ModuleRoutes from '../modules/routes';
import TopHeader from './components/header/TopHeader';
import NavSide from './components/sider/NavSide';
import ErrorBoundary from '../wrappers/others/ErrorBoundary';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const { Content } = Layout;
const MOBILE_BREAKPOINT = 992;

const Layouts = () => {
  const location = useLocation();
  const [shellReady, setShellReady] = useState(false);
  const [isMobileViewport, setIsMobileViewport] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobileViewport(isMobile);

      if (!isMobile) {
        setMobileNavOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
      <Layout className={ `app-shell${shellReady ? ' app-shell--ready' : ' app-shell--booting'}` } style={ { minHeight: '100vh', background: 'var(--klok-page-bg)' } }>
        <NavSide
          onReady={ () => setShellReady(true) }
          isMobileViewport={ isMobileViewport }
          mobileNavOpen={ mobileNavOpen }
          setMobileNavOpen={ setMobileNavOpen }
        />
        <Layout className="app-shell__main" style={ { minHeight: '100vh', background: 'transparent' } }>
          <TopHeader
            isMobileViewport={ isMobileViewport }
            mobileNavOpen={ mobileNavOpen }
            onToggleNavigation={ () => setMobileNavOpen((current) => !current) }
          />
          <Content className='maincontent'>
            <ErrorBoundary scope="page" resetKey={ location.pathname }>
              <ModuleRoutes />
            </ErrorBoundary>
          </Content>
        </Layout>
      </Layout>

  );
};

export default Layouts;
